// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"save-settings-modal_inputContainer_CgJX2","button":"save-settings-modal_button_YS6nx"};